import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface Props {
  children: ReactElement;
  isAuthenticated: boolean;
  to?: string;
}

export default function PublicRoute(props: Props) {
  const { children, isAuthenticated, to = '/' } = props;
  const { state } = useLocation();

  // If user is authenticated, check for pending payment first
  if (isAuthenticated) {
    // Otherwise, redirect to the intended destination
    return <Navigate to={state?.redirect || to} />;
  }

  return children;
}
